import React, { useEffect, useState, useRef } from 'react';
import 'katex/dist/katex.min.css';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import rehypeRaw from 'rehype-raw';
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeHighlight from "rehype-highlight";
import "highlight.js/styles/github.css";
import axios from "axios";
type Props = {
    requestData: any; // Định nghĩa kiểu đúng cho `requestData`
    onClose: () => void;
};

export const AskLLMPopup = ({ requestData, onClose }: Props) => {
    const [answer, setAnswer] = useState('');
    const [loading, setLoading] = useState(true);
    const t = (vi:string, en:string) => (requestData.language === "vietnamese" ? vi : en);
    // Giới hạn số lần gọi API bằng useRef
    const hasFetched = useRef(false);

    useEffect(() => {
        if (!hasFetched.current) {
            const fetchLLM = async () => {
                try {
                    const response = await axios.post("/api/askLLM", requestData);
                    let result = '';
                    if (response.data && response.data.answer) {
                        result = response.data.answer;
                    } else if (response.data && response.data.result) {
                        result = response.data.result;
                    } else if (typeof response.data === 'string') {
                        result = response.data;
                    }

                    result = Array.isArray(result) ? result.join(" ") : result;
                    
                    if (typeof result !== 'string') {
                        setAnswer('❌ Lỗi khi nhận kết quả từ AI Chatbot.');
                    } else {
                        setAnswer(result);
                    }
                } catch (err) {
                    setAnswer('❌ Lỗi khi gọi AI Chatbot.');
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            };

            fetchLLM();
            hasFetched.current = true; // Đánh dấu là đã gửi request
        }
    }, [requestData]);

    return (
        <div
            className="fixed top-1/8 left-1/2 transform -translate-x-1/2 bg-white border shadow-lg rounded-xl p-4 max-h-[90vh] overflow-auto z-50"
            style={{ width: '90vw', maxWidth: '90vw' }}
            onContextMenu={(e) => e.preventDefault()}
        >
            <h2 className="text-lg font-semibold text-blue-700 mb-2">{t('💬 Hỏi thêm AI Copilot', '💬 Explaination from AI Copilot')}</h2>
            <p className="text-gray-700 italic mb-2">"{requestData.query}"</p>
            {loading ? (
                <p className="text-gray-500 italic">{t('Đang hỏi AI Chatbot...', 'Asking AI Chatbot...')}</p>
            ) : (
                <div className="text-base">
                    <ReactMarkdown
                        remarkPlugins={[remarkGfm, remarkMath]}
                        rehypePlugins={[rehypeHighlight, rehypeKatex, rehypeRaw]}
                        components={{
                            h1: ({ node, ...props }) => <h1 className="text-2xl font-bold my-4" {...props} />,
                            h2: ({ node, ...props }) => <h2 className="text-xl font-bold my-3" {...props} />,
                            h3: ({ node, ...props }) => <h3 className="text-lg font-bold my-2" {...props} />,
                            p: ({ node, ...props }) => <p className="my-2" {...props} />,
                            strong: ({ node, ...props }) => <strong className="font-bold" {...props} />,
                            em: ({ node, ...props }) => <em className="italic" {...props} />,
                            ul: ({ node, ...props }) => <ul className="list-disc pl-6 my-2" {...props} />,
                            ol: ({ node, ...props }) => <ol className="list-decimal pl-6 my-2" {...props} />,
                            li: ({ node, ...props }) => <li className="my-1" {...props} />,
                            blockquote: ({ node, ...props }) => <blockquote className="border-l-4 border-gray-300 pl-4 italic my-2" {...props} />
                        }}
                    >
                        {answer}
                    </ReactMarkdown>
                </div>
            )}
            <div className="text-right mt-4">
                <button onClick={onClose} className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700">
                    {t('Đóng', 'Close')}  
                </button>
            </div>
        </div>
    );
};

export default AskLLMPopup;
